export const testimonials = [
    {
      type: "Hospital / Institutional Client",
      text:
        "We have been sourcing orthopedic and hygiene products from this team for over 2 years now. Their product quality, timely delivery, and professional approach make them a reliable partner for our hospital needs.",
      name: "Dr. Anil Verma",
      // designation: "Medical Superintendent, City Care Hospital, Delhi",
    },
    {
      type: "Distributor / Dealer",
      text:
        "As a distributor, consistency and authenticity matter the most. Their support team is always responsive.",
      name: "Rakesh Jain",
      // designation: "Distributor, Healthcare Supplies, Jaipur",
    },
    {
      type: "Clinic / Physiotherapy Center",
      text:
        "The orthopedic supports and rehabilitation products are very well-designed and comfortable for patients.",
      name: "Neha Kapoor",
      // designation: "Senior Physiotherapist, Active Life Rehab, Gurgaon",
    },
    {
      type: "Retail / Pharmacy Owner",
      text:
        "Their range of cotton hygiene and medical dressing products sells very well in our pharmacy.",
      name: "Amit Sharma",
      // designation: "Owner, MedPlus Pharmacy, Noida",
    },
    {
      type: "Bulk / OEM Client",
      text:
        "We opted for bulk supply and private labeling. The entire process was smooth and professional.",
      name: "Procurement Team",
      // designation: "Wellness Distribution Pvt. Ltd., Mumbai",
    },
  ];
  